import React, { useState, useEffect } from 'react';
import './ImageCarousel.css';

const ImageCarousel = ({ media }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        if (media && media.length > 0) {
            setCurrentIndex(0);
        }
    }, [media]);

    const nextMedia = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % media.length);
    };

    const prevMedia = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + media.length) % media.length);
    };

    if (!media || media.length === 0) {
        return <div>No hay contenido multimedia disponible</div>;
    }

    const currentFile = media[currentIndex];
    const isVideo = currentFile.endsWith('.mp4');

    return (
        <div className="carousel">
            {media.length > 1 && (
                <button className="carousel-button prev" onClick={prevMedia}>&lt;</button>
            )}

            {isVideo ? (
                <video
                    key={currentIndex}
                    src={currentFile}
                    autoPlay
                    muted
                    loop
                    className="product-detail-video fade-in"
                />
            ) : (
                <img
                    src={currentFile}
                    alt={`Product image ${currentIndex + 1}`}
                    className="product-detail-image fade-in"
                />
            )}

            {media.length > 1 && (
                <button className="carousel-button next" onClick={nextMedia}>&gt;</button>
            )}
        </div>
    );
};

export default ImageCarousel;
